import React from "react";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";

export const LoginLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    return (
      <Box
        sx={{
          height: { xs: "100vh", md: "100vh" },
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Video Background for Mobile */}
        <Box
          component="video"
          autoPlay
          muted
          loop
          playsInline
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        >
          <source src="/bg-video.mp4" type="video/mp4" />
        </Box>

        {/* Overlay for Mobile */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1,
          }}
        />

        {/* Content Container for Mobile */}
        <Container
          maxWidth="sm"
          disableGutters
          sx={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            p: 2,
          }}
        >
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              display: "flex",
              alignItems: "end",
              justifyContent: "center",
              overflow: "hidden",
              minHeight: 0,
            }}
          >
            <Outlet />
          </Box>
        </Container>
      </Box>
    );
  }

  // Desktop Layout
  return (
    <Box
      sx={{
        height: { xs: "100vh", md: "100vh" },
        display: "flex",
        width: "100%",
        overflow: "hidden",
        background: (theme) =>
          `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
      }}
    >
      {/* Video Section - Left Side */}
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        sx={{
          width: "auto",
          height: "100%",
          objectFit: "contain",
          objectPosition: "top",
          maxWidth: "60%",
        }}
      >
        <source src="/bg-video.mp4" type="video/mp4" />
      </Box>

      {/* Form Section - Right Side */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: (theme) =>
            `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
          p: 4,
        }}
      >
        <Container maxWidth="sm" disableGutters>
          <Box
            component="main"
            sx={{
              width: "100%",
              overflow: "hidden",
              minHeight: 0,
            }}
          >
            <Outlet />
          </Box>
        </Container>
      </Box>
    </Box>
  );
};
